/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import config from "../config/credentialLists.config.json";
// import axios from "axios";

import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { GET_POLICY_LIST } from "../graphql";
import { VApplication } from "../../../application";

import { useEmailId } from "../../../pages/ProvisionalPage/provider";
import moment from "moment";
import { toHeaderCase } from "js-convert-case";

const getWhoamiSrv = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.AppNavigatorService") as AppNavigatorService;
};


const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IPolicyListsMethods extends IPluginMethodMap {
  getPolicyListsProps(args: any): Promise<any>;
}

export interface IArchivedPolicyProps {
  offset?: number;
  size?: number;
  where?: any;
}

export class PolicyListsService implements IAgentPlugin {
  
  readonly methods: IPolicyListsMethods;

  constructor() {
    this.methods = {
      getPolicyListsProps: this.getProps.bind(this),
    };
  }

  async getProps(args: IArchivedPolicyProps) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    const { email } = useEmailId();
    let _where1 = args?.where?.filter(
      (item:any) => item?.column === "policyNumber" || item?.column ==="status"
    );
    let _where2 = args?.where?.filter(
      (item:any) => item?.column !== "policyNumber" && item?.column !== "status"
    );
    try {
      if (client) {
        const res = await client.query({
          query: GET_POLICY_LIST,
          variables: {
            input: {
              skip: args?.offset ?? 0,
              limit: args?.size ?? 10,
              where: [
                {
                  column: "status",
                  value: ["EXPIRED", "CANCELED"],
                  op: "In",
                },
                ..._where1,
              ],
              order: [
                {
                  column: "purchasedAt",
                  direction: "DESC",
                },
              ],
              relationFilter: {
                purchasedBy: {
                  where: [..._where2],
                  limit: args?.size ?? 10,
                  skip: args?.offset ?? 0,
                },
              },
            },
          },
          fetchPolicy: "network-only",
        });
        if (res?.data) {
          console.log(`table data`, res);
          let _rowData = this.formatTable(res?.data?.getListOfPolicies?.data);
          return {
            //...config,
            ultTableHeader:await this.getRowData(),
            ultUsers: _rowData,
            isEmpty: res?.data?.getListOfPolicies?.data?.length <= 0,
            activePage: res?.data?.getListOfPolicies?.currentPage,
            pageSize: res?.data?.getListOfPolicies?.pageSize,
            totalCount: res?.data?.getListOfPolicies?.totalCount,
            totalPages: res?.data?.getListOfPolicies?.totalPages,
          };
        }
      }
    } catch (err: any) {
      return {
        isEmpty: true,
      };
    }
  }

  private formatTable(tableData: any) {
    let _rowData =
      Array.isArray(tableData) &&
      tableData.map((item: any) => {
        return {
          rowData: item,
          id: item?.policyId,
          vid: item?.purchasedBy?.vuid,
          policyNo: item?.policyNumber,
          name: `${toHeaderCase(item?.purchasedBy?.firstName ?? "")} ${toHeaderCase(item?.purchasedBy?.lastName ?? "")}`,
          email: item?.purchasedBy?.email,
          status:item?.status,
          dateCreated: item?.purchasedAt
            ? moment(item?.purchasedAt).format("LLL")
            : "-",
          coverage: item?.coverage,
          premium: item?.premium,
          discount:(item?.discountedPremium && item?.discountedPremium !== item?.premium )? item?.discountedPremium : "NA" ,
          policyOption: `Policy Option ${item?.productDefination}`,
        };
      });
    return _rowData;
  }
  // return { ...(config || {}) };
  // private async getRowData() {
  //   let _temp = [];
  //   let whoami = await getWhoamiSrv()?.whoAmI();
  //   if (whoami?.whoami === "RISK_CAPITAL") {
  //     _temp.push({
  //       ultTableHeader: [
  //         "Name",
  //         "Policy No",
  //         "Coverage",
  //         "Premium",    
  //         "Policy Option",
  //         "Date Purchased",
  //         "Action"
  //       ],
  //     });
  //   }
  //   else {
  //     _temp.push({
  //       ultTableHeader: [
  //         "Name",
  //         "Policy No",
  //         "Coverage",
  //         "Premium",  
  //         "Discount Premium",  
  //         "Policy Option",
  //         "Date Purchased",
  //         "Action"
  //       ],
  //     });
  //   }
  //   return [..._temp];
  // }
  private async getRowData() {
     return [...config?.ultTableHeaderUser];
    // let whoami = await getWhoamiSrv()?.whoAmI();
    // if (whoami?.whoami === "RISK_CAPITAL") {   
    //     return [ 
    //       "Name",
    //       "Policy No",
    //       "Coverage",
    //       "Premium",    
    //       "Policy Option",
    //       "Date Purchased",
    //       "Action"]
      
    // }
    // else { 
    //     return [ 
    //       "Name",
    //       "Policy No",
    //       "Coverage",
    //       "Premium", 
    //       "Discount Premium" ,  
    //       "Policy Option",
    //       "Date Purchased",
    //       "Action"]
      
    // }
  }
}
